import React from 'react';
import {
  Trees,
  Sparkles,
  Users,
  GraduationCap,
  Instagram,
  Facebook,
  MessageCircle,
  ChevronRight
} from 'lucide-react';

const LandingPage = () => {
  const whatsappNumber = "3146939016"; //

  return (
    <div className="min-h-screen font-sans selection:bg-yellow-200">
      {/* NAVBAR */}
      <nav className="fixed w-full z-50 bg-white/80 backdrop-blur-md border-b border-green-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full flex items-center justify-center text-white shadow-lg">
              <img src='/logo.png' />
            </div>
            <span className="text-xl font-black text-gray-800 tracking-tight">Moraleja<span className="text-green-500 text-sm italic"> Jardín Infantil Campestre</span></span>
          </div>
          <a
            href={`https://wa.me/${whatsappNumber}`}
            className="bg-yellow-400 hover:bg-yellow-500 text-yellow-900 px-6 py-2.5 rounded-full font-bold text-sm transition-all shadow-md active:scale-95"
          >
            ¡Escríbenos! 📲
          </a>
        </div>
      </nav>

      {/* HERO SECTION */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-b from-blue-50 to-white overflow-hidden">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative z-10 space-y-8">
            <span className="inline-block px-4 py-1.5 bg-green-100 text-green-700 rounded-full text-sm font-bold uppercase tracking-wider animate-bounce">
              🌱 Matrículas Abiertas 2026
            </span>
            <h1 className="text-5xl lg:text-7xl font-black text-gray-900 leading-[1.1]">
              Aprender y crecer es una <span className="text-blue-500 decoration-8 underline-offset-8">experiencia inolvidable</span> 🌈
            </h1>
            <p className="text-lg text-gray-600 font-medium max-w-lg leading-relaxed">
              Educación constructivista en un entorno campestre donde cada niño es el protagonista de su propio descubrimiento. 🌳
            </p>
            <div className="flex flex-wrap gap-4">
              <a href={`https://wa.me/${whatsappNumber}`} target='_blank'>
                <button className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-3xl font-black text-lg shadow-xl shadow-green-200 transition-all flex items-center gap-2">
                  Conocer más <ChevronRight size={20} />
                </button>
              </a>
              <div className="flex -space-x-3 items-center">
                {[1, 2, 3, 4].map(i => (
                  <div key={i} className="w-12 h-12 rounded-full border-4 border-white bg-gray-200 overflow-hidden shadow-sm">
                    <img src={`/${i}.png`} alt="Kid" />
                  </div>
                ))}
                <span className="pl-6 text-sm font-bold text-gray-500">+50 niños felices</span>
              </div>
            </div>
          </div>

          <div className="relative">
            {/* Aquí iría el Banner / Imagen Principal */}
            <div className="relative z-10 rounded-[3rem] overflow-hidden shadow-2xl rotate-2 hover:rotate-0 transition-transform duration-500 aspect-square bg-blue-200">
              <img
                src="/jardin.jpg"
                alt="Jardín Campestre"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Formas decorativas */}
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-yellow-300 rounded-full blur-3xl opacity-50 animate-pulse"></div>
            <div className="absolute -bottom-10 -left-10 w-56 h-56 bg-green-300 rounded-full blur-3xl opacity-50 animate-pulse delay-700"></div>
          </div>
        </div>
      </section>

      {/* VALORES / MODELO */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto text-center space-y-4 mb-16">
          <h2 className="text-4xl font-black text-gray-800 tracking-tight">Nuestro Camino Juntos 🌟</h2>
          <p className="text-gray-500 font-medium max-w-2xl mx-auto">
            Apostamos por un modelo donde cada niño explora su entorno respetando su propio ritmo.
          </p>
        </div>

        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
          <FeatureCard
            icon={<Sparkles className="text-yellow-500" />}
            title="Constructivismo"
            desc="El niño es protagonista de su aprendizaje a través de la exploración." //
            color="bg-yellow-50"
          />
          <FeatureCard
            icon={<Trees className="text-green-500" />}
            title="Entorno Campestre"
            desc="Espacios naturales que enriquecen la creatividad y el bienestar." //
            color="bg-green-50"
          />
          <FeatureCard
            icon={<Users className="text-blue-500" />}
            title="Semi-Personalizada"
            desc="Respetamos los talentos únicos con atención dedicada a cada pequeño." //
            color="bg-blue-50"
          />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-white py-20 px-6 rounded-t-[4rem]">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-6 lg:col-span-2">
            <h3 className="text-3xl font-black tracking-tight">Jardín Infantil Campestre Moraleja 🌱</h3>
            <p className="text-gray-400 max-w-sm">
              Transformando juntos el futuro de nuestros pequeños con amor y naturaleza.
            </p>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/moralejaeducacion/" target='_blank' className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center hover:bg-white/20 transition-all">
                <Instagram size={24} />
              </a>
              <a href="https://www.facebook.com/moraleja.educacion/" target='_blank' className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center hover:bg-white/20 transition-all">
                <Facebook size={24} />
              </a>
            </div>
          </div>
          <div className="space-y-4">
            <h4 className="font-bold text-lg">Contacto Directo</h4>
            <p className="text-gray-400 font-medium">📲 {whatsappNumber}</p>
            <p className="text-gray-400 font-medium">📍 Ubicación Campestre - Vereda El Chagualo Marinilla</p>
          </div>
          <div className="bg-white/5 p-8 rounded-[2rem] border border-white/10">
            <p className="text-sm font-bold mb-4 italic">"Aprender y crecer sea una experiencia inolvidable"</p>
            <a href={`https://wa.me/${whatsappNumber}`} target='_blank'>
              <button className="w-full bg-yellow-400 text-yellow-900 font-black py-3 rounded-2xl">
                ¡Inscríbete Hoy!
              </button>

            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

const FeatureCard = ({ icon, title, desc, color }) => (
  <div className={`${color} p-10 rounded-[3rem] transition-all hover:-translate-y-2`}>
    <div className="bg-white w-14 h-14 rounded-2xl shadow-sm flex items-center justify-center mb-6">
      {icon}
    </div>
    <h3 className="text-xl font-bold text-gray-800 mb-2">{title}</h3>
    <p className="text-gray-600 font-medium leading-relaxed">{desc}</p>
  </div>
);

export default LandingPage;